"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = exports.stripTags = exports.jsonPostProcess = void 0;
var json_post_process_1 = require("./json-post-process");
Object.defineProperty(exports, "jsonPostProcess", { enumerable: true, get: function () { return json_post_process_1.jsonPostProcess; } });
var strip_tags_1 = require("./strip-tags");
Object.defineProperty(exports, "stripTags", { enumerable: true, get: function () { return strip_tags_1.stripTags; } });
var truncate_1 = require("./truncate");
Object.defineProperty(exports, "truncate", { enumerable: true, get: function () { return truncate_1.truncate; } });
// Note that the wordlist purely exists to try the tree-shaking mechanism.  It consists of approximately 440KB, so it should show up handsomely.
// https://medium.com/sainsburys-engineering/tree-shaking-problems-with-component-libraries-e1afe683fd29
// https://blog.theodo.com/2021/04/library-tree-shaking/
// https://redd.one/blog/building-a-tree-shakable-library-with-rollupjs
// todo: re-enable the wordlist and ensure that this is properly tree-shaken
// export { wordlist } from "./wordlist";
//# sourceMappingURL=main.js.map